export default __webpack_public_path__ + "static/media/icon-qr-passcoopeuch-appstore.0a4a5526.png";